import BaseApi from '../BaseApi';
import { SurveyConverter } from './SurveyConverter';

class SurveyApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/agent_admin/survey`;
    this.converter = new SurveyConverter();
  }

  getSurveyStatus = () =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/status`, null, null, this.converter.convertStatus);

  saveSurveyAnswer = ({ surveyId, questionId, choiceIds }) =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/answer`, {
      survey_id: surveyId,
      question_id: questionId,
      choices: choiceIds,
    });
}

export default SurveyApi;
